"use client";

import { Suspense } from "react";
import { PropertyTypeV2 } from "commonModule/services/common";
import DateSelectorForBookingFlow from "components/templates/booking/components/DateSelector";
type Props = {
  property: PropertyTypeV2;
  onDateClick: () => void;
  isDisplayClearDates?: boolean;
  className?: string;
};

// Wrapper that fires `onDateClick` only when the click target is the date
// button (id=MobileCalendarTrigger). Guest clicks pass through to
// GuestPopover's own handler. The arbitrary-variant classes neutralize the
// chip's search-bar-specific margin/height so it aligns cleanly in our card.
const DateGuestSelector = ({
  property,
  onDateClick,
  isDisplayClearDates,
  className = ""
}: Props) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = (e.target as HTMLElement);
    if (target.closest("#MobileCalendarTrigger")) {
      onDateClick();
    }
  };
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div onClick={handleClick} className={`flex items-baseline [&>div:first-child]:!mb-0 [&>div:first-child]:!h-auto [&>div:first-child]:!w-auto [&>div:first-child]:items-baseline ${className}`} data-sentry-component="DateGuestSelector" data-sentry-source-file="DateGuestSelector.tsx">
      <Suspense data-sentry-element="Suspense" data-sentry-source-file="DateGuestSelector.tsx">
        <DateSelectorForBookingFlow displayAllInPricing={true} property={property} isDisplayClearDates={isDisplayClearDates} data-sentry-element="DateSelectorForBookingFlow" data-sentry-source-file="DateGuestSelector.tsx" />
      </Suspense>
    </div>
  );
};
export default DateGuestSelector;